// Self-contained data for the Nikki Dela Peña real-estate concept website.
export const AGENT = {
  "slug": "nikki-dela-pena-real-estate-concept",
  "name": "Nikki Dela Peña",
  "shortName": "Nikki",
  "role": "Licensed Real Estate Broker · CEO, DealSeeker.PH",
  "location": "Makati City & Bonifacio Global City",
  "theme": "editorial",
  "media": {
    "hero": {
      "src": "/realestate/nikki-dela-pena/capture-070413.webp",
      "thumbnail": "/realestate/nikki-dela-pena/capture-070413-720.webp",
      "alt": "Metro Manila skyline seen from a high-rise residence",
      "label": "City homes, carefully narrowed",
      "type": "property"
    },
    "profile": {
      "src": "/realestate/nikki-dela-pena/profile.webp",
      "thumbnail": "/realestate/nikki-dela-pena/profile-720.webp",
      "alt": "Portrait of Nikki Dela Peña",
      "label": "Nikki Dela Peña",
      "type": "portrait"
    },
    "gallery": [
      {
        "src": "/realestate/nikki-dela-pena/capture-070255.webp",
        "thumbnail": "/realestate/nikki-dela-pena/capture-070255-720.webp",
        "alt": "Landscaped urban park viewed from a residence",
        "label": "Green space within the city",
        "type": "property"
      },
      {
        "src": "/realestate/nikki-dela-pena/capture-070334.webp",
        "thumbnail": "/realestate/nikki-dela-pena/capture-070334-720.webp",
        "alt": "Contemporary dining room and kitchen",
        "label": "Considered condo interiors",
        "type": "property"
      },
      {
        "src": "/realestate/nikki-dela-pena/capture-070434.webp",
        "thumbnail": "/realestate/nikki-dela-pena/capture-070434-720.webp",
        "alt": "Furnished Metro Manila condominium living room",
        "label": "Homes ready for city life",
        "type": "property"
      },
      {
        "src": "/realestate/nikki-dela-pena/capture-070818.webp",
        "thumbnail": "/realestate/nikki-dela-pena/capture-070818-720.webp",
        "alt": "DealSeeker.PH best deals in the metro graphic",
        "label": "DealSeeker.PH market positioning",
        "type": "brand"
      },
      {
        "src": "/realestate/nikki-dela-pena/capture-070854.webp",
        "thumbnail": "/realestate/nikki-dela-pena/capture-070854-720.webp",
        "alt": "DealSeeker.PH contact and services graphic",
        "label": "Buy, rent and property management",
        "type": "brand"
      },
      {
        "src": "/realestate/nikki-dela-pena/profile-2.webp",
        "thumbnail": "/realestate/nikki-dela-pena/profile-2-720.webp",
        "alt": "Alternate portrait of Nikki Dela Peña",
        "label": "A personal, attentive service",
        "type": "portrait"
      }
    ]
  },
  "accent": "#B38A55",
  "ink": "#171717",
  "paper": "#F4F2ED",
  "eyebrow": "Makati · BGC · considered city living",
  "headline": "A clearer route to the right home in Makati or BGC.",
  "intro": "A nurse-turned-realtor bringing attentive listening, practical market knowledge and hands-on negotiation to Metro Manila condo searches.",
  "promise": "Many options, carefully narrowed to what fits.",
  "proof": [
    "Rentpad member since 2015",
    "7 Rentpad reviews",
    "6 five-star reviews",
    "DealSeeker.PH founded in 2019"
  ],
  "audiences": [
    "Makati professionals",
    "BGC renters",
    "Condo owners & landlords",
    "Clients needing negotiation support"
  ],
  "services": [
    {
      "title": "Makati residences",
      "text": "A strong public listing history across Legazpi Village, Salcedo Village, Rockwell, Bel-Air and Circuit Makati."
    },
    {
      "title": "BGC & Taguig leasing",
      "text": "Studios through multi-bedroom residences across Fort Bonifacio, Uptown, Serendra and McKinley Hill."
    },
    {
      "title": "Property matching",
      "text": "Choices organized around requested location, layout, furnishings, budget and move-in requirements."
    },
    {
      "title": "Negotiation & coordination",
      "text": "Owner communication and practical lease requirements handled through the transaction."
    }
  ],
  "process": [
    "Define the location, budget and non-negotiables",
    "Shortlist appropriate available homes",
    "Arrange viewings and compare trade-offs",
    "Negotiate terms and coordinate the lease"
  ],
  "about": "Nikki’s public biography describes a career transition from licensed nursing into real estate and the founding of DealSeeker.PH in Makati in 2019. Her listing history is concentrated in condominium rentals across Makati and BGC, from efficient studios to larger premium residences.",
  "contact": {
    "phone": "+63 998 991 2347",
    "phoneHref": "+639989912347",
    "email": "nikki@dealseeker.ph"
  },
  "profiles": [
    {
      "label": "DealSeeker profile",
      "href": "https://dealseeker.ph/agent/nikki-dela-pena/",
      "imageSource": true
    },
    {
      "label": "Rentpad profile",
      "href": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88",
      "imageSource": true
    }
  ],
  "websiteAssessment": "Redesign opportunity: Nikki has a profile within DealSeeker.PH rather than a focused personal site, and many visible property entries on that profile are several years old.",
  "reviewRating": 4.9,
  "reviewCount": 7,
  "reviews": [
    {
      "author": "Jenny Marin",
      "stars": 5,
      "summary": "Describes Nikki as professional, straightforward and pleasant to work with.",
      "source": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88"
    },
    {
      "author": "Santi Santi",
      "stars": 5,
      "summary": "Highlights kindness, speed and helpful assistance.",
      "source": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88"
    },
    {
      "author": "Patrick Cabalu",
      "stars": 4,
      "summary": "Found her accommodating, helpful and knowledgeable about the property viewed.",
      "source": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88"
    },
    {
      "author": "Sherry Che",
      "stars": 5,
      "summary": "Says Nikki understood the request, communicated sincerely with the owner and acted professionally.",
      "source": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88"
    },
    {
      "author": "Acel Morong",
      "stars": 5,
      "summary": "Recommends her range of unit choices, responsible approach and help with negotiations.",
      "source": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88"
    },
    {
      "author": "Grace Hannecke",
      "stars": 5,
      "summary": "Appreciates guidance about the property, surrounding area and other practical considerations.",
      "source": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88"
    },
    {
      "author": "Anath Pillay Krisna Pillay",
      "stars": 5,
      "summary": "Says Nikki found a suitable apartment, negotiated requested items and handled the work professionally.",
      "source": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88"
    }
  ],
  "sources": [
    {
      "label": "DealSeeker.PH",
      "href": "https://dealseeker.ph/agent/nikki-dela-pena/",
      "note": "Biography, service-area mix, contact details and property history"
    },
    {
      "label": "Rentpad",
      "href": "https://rentpad.com.ph/user/nikki-dela-pena/ac6e3a7b88",
      "note": "Current market footprint, rating and all seven review records"
    }
  ]
};
